<template>

    <!-- Footer -->
    <div class="footer">
        <div class="col-12 text-center up">
            <img src="img/Tremec.png" alt="" width="150"/>
            <br /><br />

            <strong>TREMEC</strong>
            <br />
            46643 Ryan Court | Novi, Michigan 48377 USA
            <br />
            {{ $t("app.general.footer_client_service") }}: +1-800-401-9866
            <br /><br />

            
            <a href="https://www.linkedin.com/company/tremec---transmission-technologies-corporation" target="_blank"><img alt="LinkedIn" title="LinkedIn" src="img/linkedin.png" /></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://www.facebook.com/TremecPerformance/" target="_blank"><img alt="Facebook" title="Facebook" src="img/facebook.png" /></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://www.instagram.com/tremecperformance/" target="_blank"><img alt="Instagram" title="Instagram" src="img/insta.png" /></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://www.twitter.com/TREMEC" target="_blank"><img alt="Twitter" title="Twitter" src="img/twitter.png" /></a>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://www.youtube.com/TREMECtv" target="_blank"><img alt="YouTube" title="YouTube" src="img/youtube.png" /></a>
            

        </div>
        <div class="col-12 inter">&nbsp;</div>
        <div class="col-12 down">
            <div class="col-4 text-left float-left">

                <a href="https://www.kuo.com.mx/" target="_blank"><img alt="Una Empresa Kuo" title="Una Empresa Kuo" src="img/una_empresa_kuo.png" /></a>
                <!--
                <img alt="Una Empresa Kuo" title="Una Empresa Kuo" src="img/una_empresa_kuo.png" />
                -->
            </div>
            <div class="col-4 text-center float-left">
                <a :href="this.$t('app.general.link_privacy')">{{ $t("app.general.link_privacy_text") }}</a>
                &nbsp;&nbsp;|&nbsp;&nbsp; 
                <a :href="this.$t('app.general.link_terms')">{{ $t("app.general.link_terms_text") }}</a>
                &nbsp;&nbsp;|&nbsp;&nbsp; 
                <a :href="this.$t('app.general.link_ethics')">{{ $t("app.general.link_ethics_text") }}</a>
            </div>
            <!--
            <div class="col-4 text-right float-left copy">
                Copyright &copy; 2021 Tremec S.A. de C.V. - {{ $t("app.general.footer_rights") }} - www.e-comer.resirene.com
            </div>-->
        </div>
    </div>

</template>

<script>
export default {
    
}
</script>

<style scoped>

.footer{
  background-color: #ffffff;
  color: #322c24;
  width: 100%;
  padding: 10px;;
}

.footer a{
    color: #322c24;
}

.footer .inter{
    height: 40px;
    border-bottom: solid 3px #e31d1a;
}

.footer .copy{
    font-size: 8px;
}

.footer .up{
    padding-top: 10px;
    border-top: solid 3px #e31d1a;
    font-size: 16px;
}

.footer .down{
    padding-top: 10px;;
}

</style>